// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PSkinOutlinedSvg from "@fishx/icons-svg/es/asn/PSkinOutlined";
import FishxIcon from '../components/FishxIcon';

var PSkinOutlined = function PSkinOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: PSkinOutlinedSvg
  }));
};

PSkinOutlined.displayName = 'PSkinOutlined';
export default React.forwardRef(PSkinOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/PSkinOutlined.js
// module id = 3631
// module chunks = 0